import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type UpdatePdpTitleBrandV1WorkspacesWorkspaceIdPdpsPdpIdTitleBrandPatchData,
  type UpdatePdpTitleBrandV1WorkspacesWorkspaceIdPdpsPdpIdTitleBrandPatchError,
  type UpdatePdpTitleBrandV1WorkspacesWorkspaceIdPdpsPdpIdTitleBrandPatchResponse,
  updatePdpTitleBrandV1WorkspacesWorkspaceIdPdpsPdpIdTitleBrandPatch,
} from '../../generated';

export type UpdatePdpTitleBrandMutationVariables =
  UpdatePdpTitleBrandV1WorkspacesWorkspaceIdPdpsPdpIdTitleBrandPatchData['path'] &
    UpdatePdpTitleBrandV1WorkspacesWorkspaceIdPdpsPdpIdTitleBrandPatchData['body'];

export type UpdatePdpTitleBrandMutation = UpdatePdpTitleBrandV1WorkspacesWorkspaceIdPdpsPdpIdTitleBrandPatchResponse;

export const useUpdatePdpTitleBrandMutation = <
  TError = UpdatePdpTitleBrandV1WorkspacesWorkspaceIdPdpsPdpIdTitleBrandPatchError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<UpdatePdpTitleBrandMutation, TError, UpdatePdpTitleBrandMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<UpdatePdpTitleBrandMutation, TError, UpdatePdpTitleBrandMutationVariables, TContext>({
    mutationKey: ['UpdatePdpTitleBrand'],
    mutationFn: async ({ workspace_id, pdp_id, ...body }: UpdatePdpTitleBrandMutationVariables) => {
      const { data } = await updatePdpTitleBrandV1WorkspacesWorkspaceIdPdpsPdpIdTitleBrandPatch({
        path: { workspace_id, pdp_id },
        body,
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useUpdatePdpTitleBrandMutation.fetcher = (
  { workspace_id, pdp_id, ...body }: UpdatePdpTitleBrandMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await updatePdpTitleBrandV1WorkspacesWorkspaceIdPdpsPdpIdTitleBrandPatch({
      path: { workspace_id, pdp_id },
      body,
      throwOnError: true,
    });
    return data;
  };
};
